import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import { BreakGlassContext, breakGlassHeaders } from './useProjects';

export type { BreakGlassContext };

export interface ActiveSessionRow {
  sessionId: string;
  projectId: string | null;
  customerName: string | null;
  projectName: string | null;
  nameRedacted: boolean;
  phase: string;
  status: string;
  lastActivityAt: string;
  createdAt: string;
  stale: boolean;
}

export interface ActiveSessionsResponse {
  breakGlassActive: boolean;
  totalActive: number;
  groups: Record<string, ActiveSessionRow[]>;
}

export const useActiveSessions = (breakGlass?: BreakGlassContext | null) => {
  return useQuery<ActiveSessionsResponse>({
    queryKey: ['admin-active-sessions', !!breakGlass],
    queryFn: async () => {
      const response = await api.get('/api/admin/sessions/active', {
        headers: breakGlassHeaders(breakGlass),
      });
      return response.data as ActiveSessionsResponse;
    },
    refetchInterval: 30000,
    staleTime: 15000,
  });
};

export const useForceEndSession = () => {
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: async (sessionId: string) => {
      await api.post(`/api/admin/sessions/${sessionId}/force-end`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-active-sessions'] });
    },
  });
};
